module.exports = __webpack_public_path__ + "static/media/518.7bf1d446.jpg";